import I18n from 'I18n';
export const generateTimestampedName = (attemptNumber = 0, name) => {
  const timestamp = I18n.moment.portalTz().format('LL LTS z');
  if (name) {
    return `${name} (${timestamp}) ${attemptNumber > 1 ? `(${attemptNumber})` : ''}`;
  }
  return `${I18n.text('defaultForm.formName', {
    date: `(${timestamp})${attemptNumber > 1 ? ` (${attemptNumber})` : ''}`
  })}`;
};